import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const captationExpenseTarget = (search: string): string => {
  const cptId = new URLSearchParams(search).get('cptId');
  const params = new URLSearchParams({ origin: 'inversionistas', tab: 'captaciones' });
  if (cptId && /^[A-Za-z0-9_-]{1,50}$/.test(cptId)) params.set('cptId', cptId);
  return `/tesoreria/egresos?${params.toString()}`;
};

export const LegacyCaptationLiquidationRedirect: React.FC = () => {
  const { search } = useLocation();
  return <Navigate to={captationExpenseTarget(search)} replace />;
};
